/* eslint-disable no-use-before-define */
/* global ksAPI */

const pagination = () => {
  const handleRequest = event => {
    event.preventDefault();
    const content = document.querySelector('.js-paginated-content');
    const paged = event.target.dataset.link;
    const {
      type,
      pages,
      taxonomy,
      category,
      order,
      column,
      date,
      masonry,
      sticky,
      site,
      eventdate,
    } = content.dataset;
    const restUrl = content.dataset.url
      ? `https://${content.dataset.url}/wp-json/wp/v2/`
      : `${ksAPI.rest.url}wp/v2/`;

    const numDisplayPage = content.dataset.perpage
      ? content.dataset.perpage
      : 9;

    const ajaxUrl = document.querySelector('meta[name="adjx"]').content;
    const ajaxData = {
      action: 'ks_get_paginated_posts',
      rest_url: restUrl,
      type,
      per_page: numDisplayPage,
      page: paged,
      pages,
      taxonomy,
      category,
      order,
      column,
      date,
      masonry,
      sticky,
      site,
      eventdate,
      language: document.documentElement.lang,
    };

    const ajaxParameters = Object.entries(ajaxData)
      .map(e => e.join('='))
      .join('&');

    const xhr = new XMLHttpRequest();
    xhr.open('POST', ajaxUrl, true);

    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');

    content.classList.add('is-loading');

    xhr.onload = () => {
      const { response } = xhr;
      if (!response) {
        return;
      }
      if (['posts', 'news'].includes(type)) {
        const historyUrl = updateQueryStringParameter(
          window.location.href,
          'ks_page',
          paged,
        );
        // eslint-disable-next-line no-restricted-globals
        history.replaceState({ page: paged }, 'Title', historyUrl);
      }

      setTimeout(() => {
        content.innerHTML = response;
        const grid = document.querySelector('.js-grid');
        if (grid && window.matchMedia('(min-width: 768px)').matches) {
          document.resizeAllMasonryItems();
        }
        scrollPagination(paged);
        clickLinks();
        content.classList.remove('is-loading');
      }, 400);
    };

    // eslint-disable-next-line no-unused-vars
    xhr.onerror = response => {
      // eslint-disable-next-line no-console
      // console.error(response);
    };

    xhr.send(ajaxParameters);
  };

  const clickLinks = () => {
    const parent = document.querySelector('.js-pagination');
    if (parent) {
      const links = document.querySelectorAll('.js-pagination-link');
      links.forEach(link => {
        link.addEventListener('click', handleRequest);
      });
    }
  };

  const scrollPagination = () => {
    window.scrollTo({
      top:
        document.getElementById('content').getBoundingClientRect().top +
        window.scrollY -
        offset,
      left: 0,
      behavior: 'smooth',
    });
  };

  const updateQueryStringParameter = (uri, key, value) => {
    const newUri = uri.replace('#content', '');
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
    const separator = newUri.indexOf('?') !== -1 ? '&' : '?';
    if (newUri.match(re)) {
      return newUri.replace(re, `$1${key}=${value}$2`);
    }
    return `${newUri + separator + key}=${value}`;
  };

  const menu = document.querySelector('.js-header');
  let offset = 0;
  if (menu) {
    offset = menu.getBoundingClientRect().height;
  }

  clickLinks();
};

export default pagination;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/pagination.js